import { render, staticRenderFns } from "./Assigned.vue?vue&type=template&id=a295dbd8&scoped=true&"
import script from "./Assigned.vue?vue&type=script&lang=js&"
export * from "./Assigned.vue?vue&type=script&lang=js&"
import style0 from "./Assigned.vue?vue&type=style&index=0&id=a295dbd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a295dbd8",
  null
  
)

export default component.exports